<div class="container-fluid">
  <h2 mat-dialog-title>Create Scheduled Booking</h2>
  <div class="row">
    <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
  </div>
</div>
<form [formGroup]="recurrenceForm" (ngSubmit)="onSave()">
  <mat-dialog-content class="dialong-content-100vh">
    <div class="container-fluid">
      <!-- Basic Booking Details -->
      <div class="row">
        <div class="col-6">
          <label for="startDate">Start Date</label>
          <ejs-datepicker id="startDate" formControlName="startDateOnly" [value]="selectedStartDate"
            (change)="onStartDateChange($event.value)" placeholder="Select start date" [enabled]="enabledStates.startDate">
          </ejs-datepicker>
          <mat-error class="text-danger" *ngIf="recurrenceForm.get('startDateOnly')?.errors?.validationErrors">{{ recurrenceForm.get('startDateOnly')?.errors?.validationErrors }}</mat-error>
        </div>
        <div class="col-6">
          <label for="endDate">End Date</label>
          <ejs-datepicker id="endDate" formControlName="endDateOnly" [value]="selectedEndDate"
            (change)="onEndDateChange($event.value)" placeholder="Select end date" [enabled]="enabledStates.endDate">
          </ejs-datepicker>
          <mat-error class="text-danger" *ngIf="recurrenceForm.get('endDateOnly')?.errors?.validationErrors">{{ recurrenceForm.get('endDateOnly')?.errors?.validationErrors }}</mat-error>
        </div>
      </div>

      <div class="row">
        <div class="col-6">
          <label for="startTime">Start Time</label>
          <ejs-timepicker id="startTime" formControlName="startTimeOnly" placeholder="Select start time" format="h:mm a" 
          [enabled]="enabledStates.startTime">
          </ejs-timepicker>
          <mat-error class="text-danger" *ngIf="recurrenceForm.get('startTimeOnly')?.errors?.validationErrors">{{ recurrenceForm.get('startTimeOnly')?.errors?.validationErrors }}</mat-error>
        </div>
        <div class="col-6">
          <label for="endTime">End Time</label>
          <ejs-timepicker id="endTime" formControlName="endTimeOnly" placeholder="Select end time" format="h:mm a" 
          [enabled]="enabledStates.endTime">
          </ejs-timepicker>
          <mat-error class="text-danger" *ngIf="recurrenceForm.get('endTimeOnly')?.errors?.validationErrors">{{ recurrenceForm.get('endTimeOnly')?.errors?.validationErrors }}</mat-error>
        </div>
      </div>

      <div class="row">
        <div class="col-6">
          <label for="name">Name</label>
          <ejs-textbox type="text" id="name" formControlName="name" placeholder="Enter scheduled booking name" [enabled]="enabledStates.name">
          </ejs-textbox>
        </div>
        <div class="col-6">
          <label for="price">Price</label>
          <ejs-numerictextbox id="price" formControlName="price" placeholder="Enter price" format="c2" [enabled]="enabledStates.price">
          </ejs-numerictextbox>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <label for="simulatorIds">Simulators</label>
          <ejs-multiselect id="simulatorIds" formControlName="simulatorIds" [dataSource]="simulators || []"
            placeholder="Select simulators" [fields]="{ value: 'id', text: 'simulatorTitle' }"
            selectAllText="Select All" showSelectAll="true" mode="CheckBox" [showDropDownIcon]="true"
            (change)="onSimulatorChange($event)">
          </ejs-multiselect>
        </div>
        <div class="col-6">
          <label for="type">Scheduled Booking Type</label>
          <ejs-dropdownlist id="type" formControlName="type" [dataSource]="scheudledBookingTypes"
            [fields]="{ text: 'name', value: 'type' }" placeholder="Select scheduled booking type"
            (change)="onScheduledBookingTypeChange($event)">
            <ng-template #itemTemplate let-data>
              <div class="recurring-type-item">
                <div class="type-name">{{ data.name }}</div>
                <div class="type-description" *ngIf="data.description">{{ data.description }}</div>
              </div>
            </ng-template>
          </ejs-dropdownlist>
        </div>
      </div>

      <div class="row" *ngIf="leagues.length > 0">
        <div class="col-6">
          <label for="leagueId">League</label>
          <ejs-dropdownlist id="leagueId" formControlName="leagueId" [dataSource]="leagues"
            [fields]="{ text: 'name', value: 'id' }" placeholder="Select league" (change)="getLeaguesIterations($event)">
          </ejs-dropdownlist>
        </div>
        <div class="col-6">
          <label for="iterationId">Iteration</label>
          <ejs-dropdownlist id="iterationId" formControlName="iterationId" [dataSource]="leagueIterations"
            [fields]="{ text: 'year', value: 'id' }" placeholder="Select iteration" (change)="onIterationChange($event)">
            <ng-template #itemTemplate let-data>
              <div class="recurring-type-item">
                <div class="type-name">{{ data.year }}</div>
                <div class="type-description" *ngIf="data.startDate">{{ data.startDate | date:'MM/dd/yyyy' }} - {{ data.endDate | date:'MM/dd/yyyy' }}</div>
              </div>
            </ng-template>
          </ejs-dropdownlist>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="payment-link-container">
            <div class="payment-link-toggle">
              <label for="sendPaymentLink">Send Payment Link</label>
              <ejs-switch id="sendPaymentLink" formControlName="sendPaymentLink" (change)="onSendPaymentLinkChange($event)"></ejs-switch>
            </div>
            <div class="payment-link-email" *ngIf="recurrenceForm.get('sendPaymentLink')?.value">
              <label for="customerEmail">Customer Email</label>
              <ejs-textbox type="email" id="customerEmail" formControlName="customerEmail" 
                placeholder="Enter customer email address">
              </ejs-textbox>
            </div>
          </div>
        </div>
      </div>

      <!-- Recurrence Editor -->
      <div class="row">
        <div class="col-12">
          <h3>Recurrence Pattern</h3>
          <div class="recurrence-editor-container">
            <ejs-recurrenceeditor #recurrenceObj [value]="recurrenceRule" (change)="onRecurrenceChange($event.value)">
            </ejs-recurrenceeditor>
          </div>
        </div>
      </div>

      <!-- Generated Rule Display -->
      <div class="row" *ngIf="recurrenceRule">
        <div class="col-12">
          <h3>Generated Recurrence Rule</h3>
          <div class="rule-display">
            <code>{{ recurrenceRule }}</code>
          </div>
        </div>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <div class="container-fluid">
      <button mat-button class="warning" (click)="onCancel()" type="button">
        Cancel
      </button>
      <button mat-raised-button type="submit" [disabled]="!recurrenceForm.valid">
        Create Scheduled Booking
      </button>
    </div>
  </mat-dialog-actions>
</form>